import jQuery from 'jquery';
import ScrollMagic from 'scrollmagic/scrollmagic/minified/ScrollMagic.min';

class Counter {
    constructor(selector) {
        this.$container = jQuery(selector);
        this.init();
    }


    init() {
        const controller = new ScrollMagic.Controller();

        this.$container.each((index, element) => {
            const that = element;
            const initVal = that.innerText;


            new ScrollMagic.Scene({ triggerElement: that, triggerHook: 0.9, offset: '0' })
                .on('enter leave', (e) => {
                    const triggeringObj = e.currentTarget.triggerElement();

                    if (e.type === 'enter') {
                        const transformed = initVal.split('');

                        that.innerHTML = ' ';

                        transformed.forEach((item) => {
                            const valueBox = document.createElement('span');
                            that.appendChild(valueBox);
                            let iterator;

                            if (parseInt(item, 10) <= 9) {
                                const initNo = parseInt(item, 10);
                                let mixedValue = initNo;
                                let loopsCount = 0;


                                function looper() {
                                    mixedValue += 1;

                                    if (mixedValue > 9) {
                                        mixedValue = 0;
                                        loopsCount += 1;
                                    }

                                    valueBox.dataset.int_val = mixedValue;
                                    valueBox.innerHTML = `<i> ${mixedValue} </i>`;

                                    if (loopsCount >= ((Math.random() * 10) + 1) && mixedValue === initNo) {
                                        clearTimeout(iterator);
                                    } else {
                                        iterator = setTimeout(looper, 10);
                                    }
                                }

                                looper();
                            } else {
                                valueBox.innerHTML = item;
                            }
                        });
                    } else if (e.type === 'leave') {
                        triggeringObj.innerHTML = initVal;
                    }
                }).addTo(controller);
        });
    }
}

export default Counter;
